import { LucideBarChart3 } from "lucide-react";
import React from "react";

import { Stack, Heading } from "@/components/ui";

/**
 * AnalyticsHeader - Header component for Analytics screen
 *
 * @returns {JSX.Element} Die gerenderte AnalyticsHeader-Komponente
 *
 */
export const AnalyticsHeader: React.FC = () => {
  return (
    <Stack align="center" direction="row" justify="between">
      <Stack direction="col" gap={1}>
        <Heading className="text-xl font-semibold text-white" level={2}>
          Roadmap Analytics
        </Heading>
        <p className="text-slate-300">Charts & metrics of roadmap items</p>
      </Stack>
      <Stack align="center" className="text-slate-300" direction="row" gap={2}>
        <LucideBarChart3 className="w-4 h-4" />
        <span className="text-sm">Analytics View</span>
      </Stack>
    </Stack>
  );
};
